/**
 * Whether a map is in 3D, readable by any code that holds the map (#820 step 8).
 *
 * The mode used to live only in the toggle's React state and in a private
 * variable inside the AFF provider. That was enough for code that only needs to
 * hear the mode CHANGE (MODE_3D_EVENT), but not for a layer created while the
 * map is already in 3D — a drawn track, usually requested from 3D — which has to
 * ASK the current mode when it is enabled.
 *
 * Held per map in a WeakMap: each map keeps its own mode, and a map that is
 * thrown away is not kept alive by this.
 */

const modes = new WeakMap<object, boolean>();

/**
 * A map that has never been switched reads as 2D. That is its real state, not a
 * stand-in for missing information: every map starts in 2D, as the toggle's own
 * initial state does.
 */
export const isMap3D = (map: object): boolean => modes.get(map) ?? false;

/** Called by the toggle, BEFORE it announces the change, so listeners asking the mode during the event get the new one. */
export const setMap3D = (map: object, is3D: boolean): void => {
  modes.set(map, is3D);
};
